import { __extends } from "tslib";
import ViewBase from "./ViewBase";
var PersistentViewBase = /** @class */ (function (_super) {
    __extends(PersistentViewBase, _super);
    function PersistentViewBase(viewName, createViewModel, props) {
        return _super.call(this, viewName, createViewModel, props) || this;
    }
    PersistentViewBase.prototype.disposeViewModel = function () {
    };
    PersistentViewBase.prototype.getStoredViewState = function (viewModel) {
        var storedState = PersistentViewBase.storedState[this.constructor.name];
        if (!storedState) {
            storedState = this.createViewState(viewModel);
            PersistentViewBase.storedState[this.constructor.name] = storedState;
        }
        return storedState;
    };
    PersistentViewBase.storedState = {};
    return PersistentViewBase;
}(ViewBase));
export default PersistentViewBase;
